export default {
  state: {
    authUser: JSON.parse(localStorage.getItem('auth_user')) || null,
    token: localStorage.getItem('token') || null,
    permissions: localStorage.getItem('permissions') || [],
  },
  mutations: {
    SIGNIN_SUCCESS(state, payload) {
      localStorage.setItem('token', payload.access_token);
      state.token = payload.access_token;
      if (state.token) {
        window.axios.defaults.headers.common["Authorization"] = `Bearer ${state.token}`;
      }
    },
    SET_AUTH_USER(state, { user }) {
      localStorage.setItem('auth_user', JSON.stringify(user));
      state.authUser = JSON.parse(JSON.stringify(user));
    },
    SET_PERMISSIONS(state, { permissions }) {
      state.permissions = permissions;
      localStorage.setItem('permissions', JSON.stringify(permissions));
    },
    LOGOUT(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('auth_user');
      state.token = null;
      state.authUser = null;
    },
  },
  actions: {
    async SIGNIN({ commit }, { login, password }) {
      try {
        const { data } = await window.axios.post('/login', { login, password });
        commit('SIGNIN_SUCCESS', data);
      } catch (err) {
        throw err;
      }
    },
    async LOGIN_ACTIVITY() {
      try {
        await window.axios.get('/login-activity');
      } catch (err) {
        throw err;
      }
    },
    async LOGOUT({ commit }) {
      try {
        await window.axios.post('/logout');
        commit('LOGOUT');
      } catch (err) {
        throw err;
      }
    },
    async GET_AUTH_USER({ commit }) {
      try {
        const { data } = await window.axios.get('/user');
        commit('SET_AUTH_USER', data);
        commit('SET_PERMISSIONS', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    authUser(state) {
      return state.authUser;
    },
    token(state) {
      return state.token;
    },
    permissions(state) {
      return state.permissions;
    },
  },
};
